import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import type { ReactElement } from 'react';

import { DesignLayout } from '@common/DesignLayout';

import styles from './ErrorPage.module.scss';

export function ErrorPage(): ReactElement {
  return (
    <DesignLayout>
      <div className={styles.container}>
        <Icon name="infoBg" fill="red" className={styles.icon} />
        <p>Непредвиденная ошибка</p>
      </div>
    </DesignLayout>
  );
}
